// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_2g6","option":"styles_option__1COGr","selected":"styles_selected__2-vkX"};